import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  const maxColumnCount = styles.maxColumnCount || 3;
  const showVoiceOverBadge = styles.showVoiceOverBadge || false;

  return StyleSheet.create({
    videoContainer: {
      width: 'calc(49% - 30px)',
      padding: '0 15px',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'content-box',
      alignItems: 'flex-start',

      [children('img')]: {
        width: '100%',
        height: 'auto',
        cursor: 'pointer',
      },

      [children('p')]: {
        color: '#C1C0C0',
        marginBottom: 5,
      },

      [media.mobile]: {
        [children('img')]: {
          cursor: 'pointer',
        },
      },

      [media.desktop]: {
        width: `calc(${100 / maxColumnCount}% - 30px)`,

        [children('h4')]: {
          fontSize: 20,
        },
      },
    },

    thumbnailContainer: {
      position: 'relative',
      width: '100%',

      [children('img')]: {
        width: '100%',
      },
    },

    playVideo: {
      margin: '18px 0 0 0',
      width: '100%',
      borderBottom: '1px solid #E60012',
      paddingBottom: '10px',

      [media.desktop]: {
        border: 0,
        padding: 0,
      },
    },

    playVideoButton: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'center',
      verticalAlign: 'center',
      background: 'transparent',
      border: 0,
      color: '#fff',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 'bold',
      margin: 0,
      padding: 0,
      cursor: 'pointer',
      [media.tablet]: {
        fontSize: '20px',
        lineHeight: '22px',
      },
      [media.desktop]: {
        fontSize: '16px',
        lineHeight: '22px',
        ':after': {
          content: '""',
          position: 'absolute',
          top: 'calc(100% + 4px)',
          left: '0',
          // transform: 'translate(-50%, -50%)',
          height: '2px',
          width: '0%',
          backgroundColor: palette.red,
          transition: 'width .25s linear',
        },
        ':hover': {
          color: palette.red,
          ':after': {
            width: '100%',
          },
        },
      },

      [children('span')]: {
        height: '20px',
        width: 'auto',
        marginRight: '10px',
        [media.tablet]: {
          height: '25px',
        },
        [media.desktop]: {
          height: '21px',
        },
      },
      [children('svg')]: {
        height: '100%',
        width: 'auto',
        fill: palette.red,
      },
    },

    videoDisabled: {
      cursor: 'default !important',
    },

    videoHeadline: {
      display: 'flex',
      flexDirection: 'column',
      margin: '10px 0',
      color: '#fff',
      fontSize: '14px',
      lineHeight: '18px',
      [media.tablet]: {
        margin: '10px 0 13px 0',
        fontSize: '20px',
        lineHeight: '24px',
      },
      [media.desktop]: {
        margin: '10px 0 15px 0',
        fontSize: '20px',
        lineHeight: '24px',
        flexDirection: 'column-reverse',
        [children('h4')]: {
          marginBottom: showVoiceOverBadge ? '15px' : '0px',
        },
      },
    },

    voiceOverBadge: {
      width: 'fit-content',
      background: 'transparent',
      color: palette.red,
      fontWeight: 'bold',
      fontSize: '10px',
      lineHeight: '22px',
      wordBreak: 'keep-all',

      [media.tablet]: {
        fontSize: '14px',
        lineHeight: '22px',
      },
      [media.desktop]: {
        background: palette.red,
        color: '#FFF',
        padding: '5px 12px',
        borderRadius: 5,
        fontSize: '10px',
        lineHeight: '14px',
      },
    },

    speaker: {
      fontSize: '12px',
      lineHeight: '16px',

      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
    speakerName: {
      // marginBottom: '15px !important',
      fontWeight: 'bold',
    },
    speakerTitle: {},

    bioButton: {
      fontSize: '14px',
      lineHeight: '20px',
      width: 'fit-content',
      padding: '0px 12px',
      [media.tablet]: {
        fontSize: '16px',
        lineHeight: '23px',
      },
      [media.desktop]: {
        width: 'fit-content',
      },
      marginTop: 'auto',
    },
    bioButtonMobile: {
      display: 'block',
      [media.tablet]: {
        display: 'none',
      },
    },
    bioButtonTablet: {
      display: 'none',
      [media.tablet]: {
        display: 'block',
        marginTop: '22px',
      },
      [media.desktop]: {
        marginTop: '24px',
      },
    },
  });
};
